import type {
  INotifyMeSubmittedEvent,
  INotifyMeSubmittedInput,
} from '../types/clickEvents';

const notifyMeSubmitted = (
  input: INotifyMeSubmittedInput,
): Omit<INotifyMeSubmittedEvent, 'event'> => ({
  linkDetails: input.linkDetails,
});

export default notifyMeSubmitted;
